import { useEffect, useState } from "react";
import axios from "axios";

import { getPermissions } from "../api/adminApi";

const API = "http://localhost:5001/api";

const PermissionsPage = () => {

  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
  getPermissions()
    .then(res => setPermissions(res.data))
    .catch(console.error);
}, []);

  const loadPermissions = async () => {
    try {
      const res = await axios.get(`${API}/admin/permissions`);
      setPermissions(res.data || []);
    } catch (err) {
      console.error("Permission load failed", err);
    }
  };

  useEffect(() => {
    loadPermissions();
  }, []);

  return (
    <div className="space-y-6">

      <h2 className="text-xl font-black">
        Permission Matrix
      </h2>

      <div className="bg-white rounded-xl border overflow-hidden">

        <table className="w-full text-sm">
          <thead className="bg-slate-50">
            <tr>
              <th>Module</th>
              <th>Permission</th>
              <th>Description</th>
            </tr>
          </thead>

          <tbody>
            {permissions.map(p => (
              <tr key={p.PermissionID} className="border-t">
                <td>{p.ModuleName}</td>
                <td>{p.PermissionKey}</td>
                <td>{p.Description}</td>
              </tr>
            ))}
          </tbody>

        </table>

      </div>
    </div>
  );
};

export default PermissionsPage;